const newsletter = `
# eBL Newsletter 6

## 14 October 2021

### Fragmentarium

#### Photos

- Addition of all photos of K.3000s, K.20000s, and K.21000s

#### Folios

- Complete integration of Reiner Folios

#### Dictionary

- W. Sommerfeld, Akkadische Glossare und Indizes. Version 1.1 (26. Mai 2021) is
  now a part of the dictionary

#### Image Tagging

- The image tagging tool has been thoroughly revised. The new and improved version
  is running. Automatic sign recognition to aid the tagging will be added soon.

### Corpus

#### Performance

- New changes in the Corpus editor are now saved almost instantaneously.

#### Frontpage

- The proper display of the frontpage to every composition in the corpus is now
  online. The rest of the corpus display will be completed soon.

#### Translations

- It is now possible to import translations into the corpus using the same grammar
  as in the Fragmentarium, i.e. #tr.en: etc.

#### Digital Object Identifier (DOI)

- We registered the first DOI for a text-edition in the eBL-corpus
  ([https://doi.org/10.5282/ebl/l/1/2](https://doi.org/10.5282/ebl/l/1/2)). Bit
  by bit we will continue to register DOIs for every composition and chapter.`

export default newsletter
